import {
  Configuration,
  LabelsApi,
  MailingListsApi,
  SegmentsApi,
  SubscribersApi,
  type ConfigurationParameters,
} from '@teemill/mail';

import { CampaignsApi, DraftsApi } from '@teemill/mail';
import type { App } from 'vue';

let MailingListClient: MailingListsApi;
let DraftClient: DraftsApi;
let CampaignClient: CampaignsApi;
let SubscribersClient: SubscribersApi;
let SegmentsClient: SegmentsApi;
let LabelsClient: LabelsApi;

export const mail = {
  install(
    app: App,
    options: {
      client: ConfigurationParameters;
    },
  ) {
    SubscribersClient = new SubscribersApi(
      new Configuration({
        ...options.client,
        baseOptions: {
          headers: {
            'User-Agent': null,
          },
        },
      }),
    );
    MailingListClient = new MailingListsApi(
      new Configuration({
        ...options.client,
        baseOptions: {
          headers: {
            'User-Agent': null,
          },
        },
      }),
    );
    DraftClient = new DraftsApi(
      new Configuration({
        ...options.client,
        baseOptions: {
          headers: {
            'User-Agent': null,
          },
        },
      }),
    );
    CampaignClient = new CampaignsApi(
      new Configuration({
        ...options.client,
        baseOptions: {
          headers: {
            'User-Agent': null,
          },
        },
      }),
    );
    SegmentsClient = new SegmentsApi(
      new Configuration({
        ...options.client,
        baseOptions: {
          headers: {
            'User-Agent': null,
          },
        },
      }),
    );
    LabelsClient = new LabelsApi(
      new Configuration({
        ...options.client,
        baseOptions: {
          headers: {
            'User-Agent': null,
          },
        },
      }),
    );
  },
};

export {
  CampaignClient,
  DraftClient,
  LabelsClient,
  MailingListClient,
  SegmentsClient,
  SubscribersClient,
};
